/**
 * 个人中心
 */

import Container from '@/containers';

const uenterRouter = {
    path: '/ucenter',
    component: Container,
    redirect: '/ucenter/index',
    name: 'UCenter',
    meta: {
        title: '个人中心'
    },
    children: [
        {
            path: 'index',
            component: () => import('@/views/ucenter/index'),
            name: 'UCenterIndex',
            meta: {
                title: '个人中心'
            }
        },
        {
            path: 'achievement',
            component: () => import('@/views/ucenter/myAchievement'),
            name: 'MyAchievement',
            meta: {
                title: '我的成果',
                showAddBtn:true
            }
        },
        {
            path: 'collectachievement',
            component: () => import('@/views/ucenter/myCollectAchievement'),
            name: 'MyCollectAchievement',
            meta: {
                title: '我收藏的成果',
                showAddBtn:true
            }
        },
        {
            path: 'demand',
            component: () => import('@/views/ucenter/myDemand'),
            name: 'MyDemand',
            meta: {
                title: '我的需求',
                showAddBtn:true
            }
        },
        {
            path: 'collectdemand',
            component: () => import('@/views/ucenter/myCollectDemand'),
            name: 'MyCollectDemand',
            meta: {
                title: '我收藏的需求',
                showAddBtn:true
            }
        },
        {
            path: 'achdetail',
            component: () => import('@/views/ucenter/achDetail'),
            name: 'achDetail',
            meta: {
                title: '我的成果详情',
                showAddBtn:true
            }
        },
        {
            path: 'demanddetail',
            component: () => import('@/views/ucenter/demandDetail'),
            name: 'demandDetail',
            meta: {
                title: '我的需求详情',
                showAddBtn:true
            }
        },
        {
            path: 'dynamic',
            component: () => import('@/views/ucenter/myDynamic'),
            name: 'MyDynamic',
            meta: {
                title: '我的动态',
                showAddBtn:true
            }
        },
        {
            path: 'meeting',
            component: () => import('@/views/ucenter/myMeeting'),
            name: 'MyMeeting',
            meta: {
                title: '我的会议',
                showAddBtn:true
            }
        },
        {
            path: 'mycreatemeeting',
            component: () => import('@/views/ucenter/myCreateMeeting'),
            name: 'myCreateMeeting',
            meta: {
                title: '我创建的的会议',
                showAddBtn:true
            }
        },
        {
            path: 'mytrade',
            component: () => import('@/views/ucenter/myTrade'),
            name: 'myTrade',
            meta: {
                title: '我的交易',
                showAddBtn:true
            }
        },
        {
            path: 'editPersonalInformation',
            component: () => import('@/views/ucenter/editPersonalInformation'),
            name: 'EditPersonalInformation',
            meta: {
                title: '个人资料修改'
            }
        },
        {
            path: 'aboutus',
            component: () => import('@/views/ucenter/aboutus'),
            name: 'AboutUs',
            meta: {
                title: '关于我们'
            }
        }
    ]
};

export default uenterRouter;
